module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "acknowledgments-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("First of all, I would like to thank "), _c('b', [_c('i', [_vm._v("The Most High")])]), _vm._v(", for blessing me with the skills to put my thoughts on paper; my life would be nothing without You. "), _c('b', [_c('i', [_vm._v("Naleighna Kai")])]), _vm._v(", thank you for welcoming me into your family. You go above and beyond for us, and I appreciate you more than you’ll ever know. "), _c('b', [_vm._v("J.L Campbell")]), _vm._v(", thank you for helping me bring this story to life. Your guidance and patience means the world to me. "), _c('b', [_c('i', [_vm._v("Tribe")])]), _vm._v(", my life has not been the same because of you. Thank you for your love, kindness, and friendship. You guys rock! Thank you to my beta readers "), _c('b', [_c('i', [_vm._v("Marie ")])]), _vm._v("and "), _c('b', [_c('i', [_vm._v("Debra")])]), _vm._v(". A special thank you also goes out to my cousin "), _c('b', [_vm._v("Marisela ")]), _vm._v("for providing me with the pictures of our beautiful island. "), _c('b', [_vm._v("J.L. Woodson")]), _vm._v(", thank you so much for my awesome cover. And last but definitely not least, thank "), _c('b', [_c('i', [_vm._v("you all ")])]), _vm._v("for picking up a copy of Queen of Curaçao.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Much love,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Solsiré")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f08f2672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgments.vue
// module id = 66
// module chunks = 0